export const CARD_SCORES = {
    number: 'face_value',
    skip: 20,
    reverse: 20,
    draw_two: 20,
    wild: 50,
    wild_draw_four: 50,
};
export function getCardScore(card) {
    if (card.type === 'number') {
        return card.value;
    }
    return CARD_SCORES[card.type];
}
export const DEFAULT_TARGET_SCORE = 1000;
export const DEFAULT_TURN_TIME_LIMIT = 30;
export const UNO_PENALTY_CARDS = 2;
//# sourceMappingURL=scoring.js.map